import {Component, Input, OnInit} from '@angular/core';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {DocumentModel} from '../../models/document.model';
import {AlertController, ModalController} from '@ionic/angular';
import {ProductMultiSelectComponent} from '../../modals/product-multi-select/product-multi-select.component';

@Component({
    selector: 'spares-fuel-ws',
    templateUrl: './spares-fuel-ws.component.html',
    styleUrls: ['./spares-fuel-ws.component.scss'],
})
export class SparesFuelWsComponent implements OnInit {
    @Input() document: DocumentModel;
    @Input() title: string;
    detailLines: DetaillineDTOModel[];
    icon: string;

    constructor(private alertController: AlertController,
                public modalController: ModalController) {
    }

    ngOnInit() {
        console.log(this.title.toLowerCase());
        this.icon = this.getIcon();
        this.updateDetailLines();
    }

    updateDetailLines() {
        this.detailLines = this.document.detailLines.filter(line => {
            if (this.title.toLowerCase() === 'parts') {
                console.log(line.fuelProductType);
                return !line.fuelProductType;
            }
            if (this.title.toLowerCase() === 'fuel') {
                console.log(line.fuelProductType);
                return line.fuelProductType;
            }
        });
    }

    async productSelect() {
        const modal = await this.modalController.create({
            component: ProductMultiSelectComponent,
            cssClass: 'modal-fullscreen',
            backdropDismiss: false,
            componentProps: {
                document: this.document,
                behaviour: this.title
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            this.updateDetailLines();
        });
        return await modal.present();
    }

    async editItemQty(item: DetaillineDTOModel) {
        const alert = await this.alertController.create({
            header: 'Edit Product',
            message: 'Please adjust the quantity.',
            backdropDismiss: false,
            inputs: [
                {
                    name: 'itemQty',
                    type: 'number',
                    value: item.qty,
                    placeholder: 'Enter new Qty'
                },
                {
                    name: 'itemDescription',
                    type: 'text',
                    value: item.comment,
                    placeholder: 'Enter new Description'
                },
                {
                    name: 'itemPrice',
                    type: 'number',
                    value: item.total,
                    placeholder: 'Enter new Price'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                },
                {
                    text: 'Ok',
                    handler: data => {
                        item.qty = data.itemQty;
                        item.total = data.itemPrice;
                        item.comment = data.itemDescription;
                    }
                }
            ]
        });

        await alert.present();
    }

    deleteLine(item: DetaillineDTOModel) {
        // this.document.detailLines.splice(i, 1);
        console.log(this.document.detailLines.indexOf(item));
        this.detailLines.splice(this.detailLines.indexOf(item), 1);
        this.document.detailLines.splice(this.document.detailLines.indexOf(item), 1);
    }

    private getIcon() {
        switch (this.title.toLowerCase()) {
            case 'fuel':
                return 'flame';
            case 'parts':
                return 'cart';
            default:
                return 'cart';
        }
    }
}
